// eslint-disable-next-line
import React, { useState } from 'react'
import './UsageStep.scoped.sass'

import { Button } from '@/components/Button/Button'
import { ReactComponent as CheckLogo } from '@/assets/icons/check.svg'
import { ReactComponent as ComeBackArrow } from '@/assets/icons/come-back-arrow.svg'
import OnBoardingService from '@/app-domains/onboarding/onboarding.service'

const UsageStep = (props) => {
  const {
    // usage,
    closeModal,
    goToPreviousStep,
    continueOnboarding
  } = props

  const baseLabels = ['Family & Friends', 'Hobbies', 'Online Services', 'Bills & Receipts', 'Newsletters']
  // const personalLabels = ['Family', 'Friends', 'Hobbies', 'Shopping', 'Bills', 'Newsletters']
  // const businessLabels = ['Clients', 'Online Services', 'Providers', 'Management']
  // const bothLabels = personalLabels.concat(businessLabels)

  // eslint-disable-next-line
  const [isDisabled, setIsDisabled] = useState(false)

  // eslint-disable-next-line
  function getLabels () {
    /* if (usage === 'personal') {
      return personalLabels.map((label) => {
        return (
          <li key={label} className='list-item'>
            <CheckLogo />
            <span className='li-text'>{label}</span>
          </li>
        )
      }
      )
    } else if (usage === 'business') {
      return businessLabels.map((label) => {
        return (
          <li key={label} className='list-item'>
            <CheckLogo />
            <span className='li-text'>{label}</span>
          </li>
        )
      }
      )
    } else if (usage === 'both') {
      return bothLabels.map((label) => {
        return (
          <li key={label} className='list-item'>
            <CheckLogo />
            <span className='li-text'>{label}</span>
          </li>
        )
      })
    } */
    return baseLabels.map((label) => {
      return (
        <li key={label} className='list-item'>
          <CheckLogo />
          <span className='li-text'>{label}</span>
        </li>
      )
    })
  }

  function getPostDataService () {
    OnBoardingService.postUsageData('base') // Removed the use of usage here since we'll just start with a base creation
  }

  // eslint-disable-next-line
  function setButtonFunctionality () {
    getPostDataService()
    setIsDisabled(true)
    continueOnboarding()
  }
  
  // eslint-disable-next-line
  function getUsageTitle () {
    return 'Setting up some labels'
    /* if (usage === 'personal') {
      return 'Personal Usage'
    } else if (usage === 'business') {
      return 'Business Usage'
    } else if (usage === 'both') {
      return 'Both Usage'
    } */
  }

  return (
    <div className='main-container'>
      <div className='welcome-header'>
        <div className='come-back-arrow' onClick={goToPreviousStep}>
          <ComeBackArrow />
        </div>
        Regarding Labels
      </div>
      <div className='info'>
        <p>We created some labels for you automatically like Online Services, Family & Friends, Work, and more. </p>
      </div>
      <div className='info'>
        <p>Each new box created will be in your "Unlabeled" label.</p>
      </div>
      <div className='info'>
        <p>To see the new boxes, select Unlabeled. To label one of those boxes, click the menu icon on the box and choose Edit. Select one or more labels for that box and save.</p>
      </div>
      <div className='info'>
        <p><b>It's that simple.</b></p>
      </div>
      <div className='buttons'>
        <div className='skip-button'>
          <Button content='Skip' type='secondary' click={closeModal} className='skip-button' size='regular'/>
        </div>
        <div className='quick-setup-button'>
          <Button content='Continue' click={setButtonFunctionality} className='quick-setup-button' size='regular'/>
        </div>
      </div>
    </div>
  )
}

export default UsageStep
